import { render, staticRenderFns } from "./match-arrange.vue?vue&type=template&id=3d245aa2&scoped=true"
import script from "./match-arrange.vue?vue&type=script&lang=js"
export * from "./match-arrange.vue?vue&type=script&lang=js"
import style0 from "./match-arrange.vue?vue&type=style&index=0&id=3d245aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d245aa2",
  null
  
)

export default component.exports